import React, { SVGProps } from 'react';

export const ClipboardEditIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      fill="none"
      {...props}
    >
      <g fill="currentColor">
        <path
          d="M8 2.5h.5c1 0 1.5.5 1.5 1.5v5c0 1-.5 1.5-1.5 1.5h-5C2.5 10.5 2 10 2 9V4c0-1 .5-1.5 1.5-1.5H4"
          opacity=".4"
        />
        <path d="M8 2.25v.5c0 .5-.25.75-.75.75h-2.5c-.5 0-.75-.25-.75-.75v-.5c0-.5.25-.75.75-.75h2.5c.5 0 .75.25.75.75ZM5.99 5.89l1.12 1.12-2 1.99H4V7.89l1.99-2Zm1.88-.265-.495-.495a.444.444 0 0 0-.63 0l-.405.41 1.12 1.12.41-.405a.444.444 0 0 0 0-.63Z" />
      </g>
    </svg>
  );
};
